(ns common.endpoints.updates.feed-keys)

(def entity-scope :updates.feed.context/entity-scope)
(def my-tasks :updates.feed.context/my-tasks)

(def account-config :updates.feed.app/account-config)
(def tenant-config :updates.feed.app/tenant-config)

(def oppo-view :updates.feed.view/oppo)
(def kyc-process-view :updates.feed.view/kyc-process)

(def all
  #{entity-scope
    my-tasks
    account-config
    tenant-config
    oppo-view
    kyc-process-view})

